const getRumId = (pathname: string): string => {
    let result = pathname.replaceAll('/', '.');
    result = result.startsWith('.') ? result.slice(1) : result;

    return result;
};

export { getRumId };
